/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	DropDownPredicateOp,
	NumericPredicateOp,
	TextPredicateOp,
} from '../../../app-data/models/TPFilterPredicates';

export const NumericPredicateOpMap = new Map<NumericPredicateOp, string>([
	[NumericPredicateOp.EqualTo, '='],
	[NumericPredicateOp.NotEqualTo, '≠'],
	[NumericPredicateOp.LessThan, '<'],
	[NumericPredicateOp.GreaterThan, '>'],
	[NumericPredicateOp.LessThanOrEqualTo, '≤'],
	[NumericPredicateOp.GreaterThanOrEqualTo, '≥'],
	[NumericPredicateOp.NotSet, '<not set>'],
	[NumericPredicateOp.AnyValue, 'Any Value'],
]);

export const TextPredicateOpMap = new Map<TextPredicateOp, string>([
	[TextPredicateOp.Contains, 'Contains'],
	[TextPredicateOp.ExactlyMatches, 'Exactly matches'],
	[TextPredicateOp.NotSet, '<not set>'],
	[TextPredicateOp.AnyValue, 'Any Value'],
]);

export const DropDownPredicateOpMap = new Map<DropDownPredicateOp, string>([
	[DropDownPredicateOp.IsOneOf, 'Is one of'],
	[DropDownPredicateOp.NotSet, '<not set>'],
	[DropDownPredicateOp.AnyValue, 'Any value'],
]);
